import { Outlet, createFileRoute, redirect } from "@tanstack/react-router"

import { isEmbed } from "@/lib/utils"

export const Route = createFileRoute("/embed")({
  beforeLoad: () => {
    if (!isEmbed()) {
      throw redirect({ to: "/" })
    }
  },
  component: () => (
    <div className="grid h-full" data-theme="inline">
      <Outlet />
    </div>
  ),
})
